import {
  PayCalendarSalaryAllowance,
  PayCalendarSalaryAllowancePercentage,
  PayCalendarStartingBalanceDays,
} from '@aslanpay/portal-common-lib';

export enum PayCalendarLocation {
  ENGLAND_WALES = 'England & Wales',
  SCOTLAND = 'Scotland',
  NORTHERN_IRELAND = 'Northern Ireland',
  IRELAND = 'Ireland',
}

export enum PayFrequency {
  MONTHLY = 'Monthly',
  FOUR_WEEKLY = '4-weekly',
  FORTNIGHTLY = 'Fortnightly',
  WEEKLY = 'Weekly',
}

export enum NonBusinessDayFailover {
  NEXT_BUSINESS_DAY = 'Default to next business day',
  PREVIOUS_BUSINESS_DAY = 'Default to previous business day',
  NO_CHANGE = 'No change',
}

export enum PayrollCutoff {
  N_DAYS_BEFORE_PAYDAY = 'Number of days before pay day', // monthly, 4-weekly, fortnightly, weekly
  N_BUSINESS_DAYS_BEFORE_PAYDAY = 'Number of business days before pay day', // monthly, 4-weekly, fortnightly, weekly
  N_DAY_OF_PERIOD = 'Nth day of the period', // monthly, 4-weekly, fortnightly, weekly
  N_BUSINESS_DAY_OF_PERIOD = 'Nth business day of the period', // monthly
  FIXED_DAY = 'Fixed day', // monthly
  CUSTOM_DAY = 'Custom day, same month', // retire
  CUSTOM_DAY_IN_ARREARS = 'Custom day, same month as the pay day', // retire
}

export enum Payday {
  LAST_DAY_OF_PERIOD = 'Last day of the period', // monthly, 4-weekly, fortnightly, weekly
  LAST_BUSINESS_DAY = 'Last business day of the period', // monthly
  LAST_CUSTOM_WEEKDAY = 'Last custom weekday of the period', // monthly
  N_BUSINESS_DAY_OF_PERIOD = 'Nth business day of the period', // monthly, 4-weekly, fortnightly, weekly
  N_DAY_OF_PERIOD = 'Nth day of the period', // monthly, 4-weekly, fortnightly, weekly
  FIXED_DAY = 'Fixed day', // monthly
  FIRST_BUSINESS_DAY = 'First Business Day', // was exclusive to in arrears but not used now
  FIRST_CUSTOM_WEEKDAY = 'First Custom Weekday', // same as above
  LAST_DAY_OF_MONTH = 'Last day of the month',
  CUSTOM_DAY = 'Custom day, same month',
  CUSTOM_DAY_IN_ARREARS = 'Custom day, next month',
}

export enum PayCalendarWorkingDay {
  MONDAY = 'Monday',
  TUESDAY = 'Tuesday',
  WEDNESDAY = 'Wednesday',
  THURSDAY = 'Thursday',
  FRIDAY = 'Friday',
  SATURDAY = 'Saturday',
  SUNDAY = 'Sunday',
}

export enum AccrualPeriodType {
  PAY_CYCLE_TO_PAY_CYCLE = 'Start date to end date',
  CUTOFF_TO_CUTOFF = 'Cutoff to cutoff',
  PAYDAY_TO_PAYDAY = 'Payday to payday',
}

export enum PayType {
  IN_PERIOD = 'In period',
  IN_ARREARS = 'In arrears',
}

export enum DeductionsConfigurations {
  EARNINGS_PAY_CYCLE_START = 'Start of the Period',
  DEDUCTIONS_PAY_CYCLE_CUTOFF = 'On Cutoff',
  DEDUCTIONS_PAY_CYCLE_PAYDAY = 'On Payday',
}

export const allowedPresetValues: number[] = [5, 10, 15, 20, 25, 30];

export const odpAllowancePercentageValues: PayCalendarSalaryAllowance[] = [
  5, 10, 15, 17, 20, 25, 30, 35, 40, 45, 50,
];

export const odpAllowancePercentagePercentageValues: PayCalendarSalaryAllowancePercentage[] = [
  { label: '5%', percentage: 5 },
  { label: '10%', percentage: 10 },
  { label: '15%', percentage: 15 },
  { label: '20%', percentage: 20 },
  { label: '25%', percentage: 25 },
  { label: '30%', percentage: 30 },
  { label: 'Custom %', percentage: 200 },
];

export const globalAllowancePercentageValues: PayCalendarSalaryAllowancePercentage[] = [
  { label: '5%', percentage: 5 },
  { label: '10%', percentage: 10 },
  { label: '15%', percentage: 15 },
  { label: '20%', percentage: 20 },
  { label: '25%', percentage: 25 },
  { label: '30%', percentage: 30 },
  { label: '35%', percentage: 35 },
  { label: '40%', percentage: 40 },
  { label: '45%', percentage: 45 },
  { label: '50%', percentage: 50 },
  { label: 'Custom %', percentage: 200 },
];

export const startingBalanceDaysValues: PayCalendarStartingBalanceDays[] = [
  { label: 'Pay calendar default - 4 working days', balance: 4 },
  { label: '0', balance: 0 },
  { label: '1', balance: 1 },
  { label: '2', balance: 2 },
  { label: '3', balance: 3 },
  { label: '5', balance: 5 },
  { label: '6', balance: 6 },
  { label: '7', balance: 7 },
  { label: '8', balance: 8 },
  { label: '9', balance: 9 },
  { label: '10', balance: 10 },
  { label: '11', balance: 11 },
  { label: '12', balance: 12 },
  { label: '13', balance: 13 },
  { label: '14', balance: 14 },
  { label: '15', balance: 15 },
  { label: '16', balance: 16 },
  { label: '17', balance: 17 },
  { label: '18', balance: 18 },
  { label: '19', balance: 19 },
  { label: '20', balance: 20 },
  { label: 'Whole period - all working days', balance: 100 },
];
